import { Post } from '@/@types/post'
import { MouseEvent } from 'react'
import { fetchAndCachePost } from '../fetchers/post'
import { toRoutePathParam } from '../route'
import useUniversalNavigate from './useUniversalNavigate'

export default function usePostDrawerOpener() {
	const navigate = useUniversalNavigate()
	return async (data: Post, e: MouseEvent) => {
		const type = toRoutePathParam(data.type)

		await fetchAndCachePost(data.id, data.type)
		navigate(
			{
				mask: {
					to: '/u/$username/$type/$id',
					params: {
						username: data.user!.username,
						id: data.id,
						type,
					},
					unmaskOnReload: true,
				},
				search: (prev: Record<string, unknown>) => ({
					...prev,
					id: data.id,
				}),
			},
			e
		)
	}
}
